<template>
    <div>
        <content-write-link v-for="writeLayout in writeLayouts" :key="`contentComp${writeLayout}`" :writeLayout="writeLayout" :contentData="contentData" :Categories="Categories" :optionData="optionData" :streamingKey="streamingKey"></content-write-link>
    </div>
</template>

<script>
    import ContentWriteLink from "@/components/content/ContentWriteLink";
    import contentUtil from "@/components/content/contentUtil";
    import util from "@/mixins/util";
    import alertMixins from "@/mixins/alertMixins";
    import elFileMixins from "@/mixins/elFileMixins";
    import EventBus from "@/utils/event-bus";
    import contentValidator from "@/mixins/validators/contentValidator";
    import vimeoPlugin from "@/plugins/vimeoPlugin";
    let vimeoParams = {
        privacy: {
            view: 'unlisted',
            comments: 'contacts',
            download: false,
            add: false,
        },
        embed: {
            buttons: {
                like: false,
                share: false,
                watchlater: false,
                embed: false,
            },
            logos: {
                vimeo: false,
            },
            title: {
                name: 'hide',
                owner: 'hide',
                portrait: 'hide'
            },
        },
    };
    export default {
        name: "RegularWriteComponent",
        mixins: [contentUtil, alertMixins, elFileMixins, contentValidator],
        components: {ContentWriteLink},
        provide() {
            return {
                contentWriteSetData: this.setData,
            }
        },
        inject: [],
        props: {
            contentType: {default: ''},
            contentKey: {default: 0},
            streamingKey:{default:0}
        },
        data() {
            return {
                writeLayouts: [],
                getCategoryFunc: '',
                categoryApiParamsSet: {},
                getFunc: '',
                detailApiParamsSet: {},
                getDetailParamsKey: '',
                writeFunc: '',
                writeApiParamSet: {},
                parsingData: {},
                directUrl: '',
                directType: '',
                keyName: '',
                writeSuccessType: 1,
                writeFailTypes: {},
                fileType: '',

                contentData: {},
                optionData: [],
                Categories: [],
                selectedImageOption: {},
                vimeoPlugin: null,
                bookList:[],
                bookListUse : false,
                isVideoUpdateDone : false,
                isDone : false,
                nowContentKey:0,
                isRunning:false,
            }
        },
        created() {
            this.initFilterConfig();
            this.getCategory();
            if(this.contentKey === 0) {
                this.initTemplateConfig();
            }else{
                this.getContent();
            }

        },
        mounted() {
            EventBus.$on('writeRegular', this.writeContent);
        },
        beforeDestroy() {
            EventBus.$off('writeRegular')
        },
        destroyed() {},
        computed: {
        },
        methods: {
            setData(type, value) {
                this[type] = value;
            },
            initTemplateConfig() {
                let config = this.returnContentConfig(this.contentType);
                this.writeLayouts = config.writeLayouts;
            },
            initFilterConfig() {
                let config = this.returnContentConfig(this.contentType);
                this.getCategoryFunc =  config.getCategoryFunc;
                this.categoryApiParamsSet = config.categoryApiParamsSet;
                this.getFunc = config.getFunc;
                this.detailApiParamsSet = config.detailApiParamsSet;
                this.getDetailParamsKey = config.getDetailParamsKey;
                this.writeFunc = config.writeFunc;
                this.writeApiParamSet = config.writeApiParamSet;
                this.parsingData = config.parsingData;
                this.directUrl = config.directUrl;
                this.directType = config.directType;
                this.fileType = config.fileType;
                this.keyName = config.keyName;
                this.writeSuccessType = config.writeSuccessType;
                this.writeFailTypes = config.writeFailTypes;
                this.vimeoPlugin =  new vimeoPlugin();
                this.vimeoPlugin.init(vimeoParams);
            },
            getCategory() {
                if(util.isEmpty(this.getCategoryFunc)) {
                    return false;
                }
                let params = Object.assign({}, this.categoryApiParamsSet);

                try {
                    this.$api.$content[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type === 1) {
                            this.Categories = res.List;
                        }
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            getContent() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
                params[this.getDetailParamsKey] = this.contentKey;
                this.$api.$content[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type != 1 || util.isEmpty(res.List)) {
                        this.createAlert({
                            title: '',
                            content: '데이터를 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                            }
                        });
                        return;
                    }
                    if(res.List.hasOwnProperty('Content')) {
                        this.contentData = res.List.Content[0];
                    }
                    this.getVideoOption();

                    if(!util.isEmpty(this.contentData.Ref)) {
                        this.bookListUse = true;
                    }
                    this.initTemplateConfig();
                })
            },
            getVideoOption() {
                let params = {
                    type: 'video',
                    cid: this.contentKey,
                    cf:1
                }
                try {
                    this.$api.$content.getContent(params).then(res => res.Data.Result).then(res => {
                        if(!util.isEmpty(res.List) && res.Info.type === 1) {
                            this.optionData = res.List;
                        }
                    })
                }catch (e) {
                    console.log(e)
                }
            },
            _checkValidator(){
                if (this.bookList.length > 0 && this.bookList[this.bookList.length - 1].cr_name == '') {
                    this.errorAlert('교재명을 입력해주세요.');
                    return false;
                }

                let validatorArr = Object.keys(this.parsingData);
                validatorArr.push('videoFile');
                if(!util.isEmpty(this.fileType)) {
                    validatorArr.push('files')
                }
                return this.$validate(validatorArr).then(success => {
                    if (!success) {
                        this.errorAlert('필수데이터를 확인해주세요.')
                        util.Array.each(this.writeLayouts, (layout, index, arr) => {
                            EventBus.$emit(`${layout}Validator`, validatorArr);
                        });
                        return success
                    }
                    return success;
                })
            },
            _makeParams(){
                let params = Object.assign({}, this.writeApiParamSet);
                util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                    params[paramKey] = this[dataKey];
                })
                if(this.contentKey != 0) {
                    params[this.keyName] = this.contentKey;
                }
                if(this.bookList.length > 0) {
                    params.ref = this.createBookParams();
                }
                if(this.bookListUse && this.bookList.length == 0) {
                    params.ref_type = "delete"
                }
                return params;
            },
            async writeContent() {
                if(this.isRunning) return false;
                this.changeLoading(true);
                let validator = await this._checkValidator();
                if(!validator){
                    this.changeLoading(false);
                    return false;
                }
                let params = this._makeParams();
                try {
                    this.$api.$content[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnWriteType(res.Info.type);
                        if(type != true) {
                            this.errorAlert(type);
                            this.changeLoading(false);
                            return false;
                        }
                        type = !util.isEmpty(this.optionData) ? 'update':'create';

                        this.nowContentKey= res.List;
                        if(!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles)
                        }
                        if(!util.isEmpty(this.fileType) && !util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0){
                            this.uploadFiles(this.files, this.fileType, res.List).then(success => {
                                if(!util.isEmpty(this.bookFile) && this.bookFile.filter(file => file.hasOwnProperty('raw')).length > 0){
                                    this.uploadFiles(this.bookFile, 'content_file', res.List).then(success => {
                                        this.runVideoOption(type);
                                    });
                                }else{
                                    this.runVideoOption(type);
                                }
                            });
                        }else{
                            if(!util.isEmpty(this.bookFile) && this.bookFile.filter(file => file.hasOwnProperty('raw')).length > 0){
                                this.uploadFiles(this.bookFile, 'content_file', res.List).then(success => {
                                    this.runVideoOption(type);
                                });
                            }else{
                                this.runVideoOption(type);
                            }
                        }
                    })
                }catch (e) {
                    this.changeLoading(false);
                    console.log(e)
                }

            },
            returnWriteType(type) {
                if(type == this.writeSuccessType) {
                    return true;
                }else{
                    return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
                }
            },
            afterFunc() {
                this.changeLoading(false);
                this.createAlert({
                    title: '',
                    content: '저장되었습니다.',
                    btnText: '확인',
                    hide: () => {
                        if(this.directType === 'back') {
                            this.$router.back();
                            return false;
                        }
                        if(this.directUrl === '') {
                            this.writeLayouts = [];
                            this.deleteFiles = [];
                            this.getContent();
                            return false;
                        }
                        let url = this.directUrl;
                        if(this.directType === 'detail') {
                            url = url+this.nowContentKey;
                        }
                        this.$router.push(url);
                    }
                })
            },
            runVideoOption(type='create') {
                if(type === 'create') {
                    this.createVideoOption()
                }else if(type === 'update') {
                    this.updateVideoOption();
                }
            },
            createVideoOption() {
                if(!util.isEmpty(this.videoFile) && this.videoFile.filter(file => file.hasOwnProperty('raw')).length > 0){
                    this.vimeoPlugin.runUpload(this.videoFile[0].raw).then(res => {
                        let uri = res;
                        let cv_vimeo = uri.replace('/videos/', '');
                        this.sendCreateVideoApi(cv_vimeo);
                    }, err => {
                        this.changeLoading(false);
                        this.errorAlert('비디오 업로드에 실패하였습니다.');

                    });
                }else{
                    this.sendCreateVideoApi()
                }

            },
            sendCreateVideoApi(cv_vimeo='') {
                let params = {
                    type: 'video',
                    c_idx: this.nowContentKey,
                    cv_content: this.content,
                    cv_is_premium: this.premium,
                    cv_title : this.subTitle
                }
                if(!util.isEmpty(cv_vimeo)) {
                    params.cv_vimeo = cv_vimeo;
                }

                try {
                    this.$api.$content.createContent(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnVideoCreateType(res.Info.type);
                        if(type === true) {
                            this.afterRunVideoOption();
                        }else{
                            this.errorAlert(type);
                        }
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            returnVideoCreateType(type) {
                switch (type) {
                    case 1:
                        return true;
                    case -101:
                        return '통신이 실패하였습니다.';
                    default:
                        return '저장에 실패하였습니다.';
                }
            },
            updateVideoOption() {
                if(!util.isEmpty(this.videoFile) && this.videoFile.filter(file => file.hasOwnProperty('raw')).length > 0){
                    this.vimeoPlugin.runUpload(this.videoFile[0].raw, this.optionData[0].cv_vimeo).then(res => {
                        let uri = res;
                        let cv_vimeo = uri.replace('/videos/', '');
                        this.sendUpdateVideoApi(cv_vimeo);
                    }, err => {
                        this.vimeoPlugin.runUpload(this.videoFile[0].raw).then(resUpload => {
                            let uri = resUpload;
                            let cv_vimeo = uri.replace('/videos/', '');
                            this.sendUpdateVideoApi(cv_vimeo);
                        }, err => {
                            this.changeLoading(false);
                            console.log(err);
                            this.errorAlert('비디오 업로드에 실패하였습니다.');

                        })

                    });
                }else{
                    this.sendUpdateVideoApi()
                }
            },
            sendUpdateVideoApi(cv_vimeo) {
                let params = {
                    type: 'video',
                    cv_idx: this.optionData[0].cv_idx,
                    cv_content: this.content,
                    cv_is_premium: this.premium,
                    cv_title : this.subTitle
                }
                if(!util.isEmpty(cv_vimeo)) {
                    params.cv_vimeo = cv_vimeo;
                }

                try {
                    this.$api.$content.updateContent(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnVideoUpdateType(res.Info.type);
                        if(type === true) {
                            this.afterRunVideoOption();
                        }else{
                            this.errorAlert(type);
                        }
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            returnVideoUpdateType(type) {
                switch (type) {
                    case 1:
                        return true;
                    case -101:
                        return '통신이 실패하였습니다.';
                    case -400:
                        return '삭제된 비디오 콘텐츠 입니다.';
                    case -403:
                        return '권한이 없습니다.';
                    case -404:
                        return '비디오가 존재하지 않습니다.';
                    default:
                        return '저장에 실패하였습니다.';
                }
            },
            afterRunVideoOption() {
                this.getVideoOption();
                this.isVideoUpdateDone = true;
                this.afterFunc();
            },
            createBookParams(){
                let bookParams = []
                util.Array.each(this.bookList, (item, index, book) => {
                    bookParams.push({name:item.cr_name , url:item.cr_url})
                });
                return bookParams;
            },
            changeLoading(value){
                this.isRunning = value;
                EventBus.$emit('apiLoading',value);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
